import React, { useEffect } from 'react';
import { Button } from './Button';

export function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  primaryLabel = '保存',
  secondaryLabel = 'キャンセル',
  onPrimary,
  onSecondary,
  primaryVariant = 'primary',
  size = 'md',
  hideFooter = false,
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const widths = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-slate-900/40 backdrop-blur-[1px]"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className={`relative w-full ${widths[size] || widths.md} bg-prodia-surface border border-prodia-border rounded-xl shadow-prodia-lg max-h-[90vh] flex flex-col`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'modal-title' : undefined}
      >
        {title && (
          <div className="flex items-center justify-between px-5 py-4 border-b border-prodia-border flex-shrink-0">
            <h2 id="modal-title" className="text-base font-semibold text-prodia-text-primary">
              {title}
            </h2>
            <button
              type="button"
              onClick={onClose}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-prodia-text-muted hover:bg-prodia-background hover:text-prodia-text-primary transition-colors"
              aria-label="閉じる"
            >
              <i className="fas fa-times text-sm" />
            </button>
          </div>
        )}
        <div className="px-5 py-4 overflow-y-auto flex-1">{children}</div>
        {!hideFooter && (footer || onPrimary || onSecondary) && (
          <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-prodia-border flex-shrink-0">
            {footer || (
              <>
                {(onSecondary || onClose) && (
                  <Button variant="secondary" onClick={onSecondary || onClose}>
                    {secondaryLabel}
                  </Button>
                )}
                {onPrimary && (
                  <Button variant={primaryVariant} onClick={onPrimary}>
                    {primaryLabel}
                  </Button>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Modal;
